import { createContext } from "react";
import useStageDetailsByProjectIdStageId from "../hooks/data/useStageDetailsByProjectIdStageId";

export interface IStageDetailsContext extends ReturnType<typeof useStageDetailsByProjectIdStageId> {

};

const StageDetailsContext = createContext<IStageDetailsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default StageDetailsContext